// extracted by mini-css-extract-plugin
export default {"container":"CJ-z","dimension":"DJ-z","dimensionLabels":"EJ-z"};